<i class="icon" role="img" [style]="iconStyle" aria-hidden="true"></i>
